export default __webpack_public_path__ + "static/media/arrow_down_icon--white.241dd285.svg";